module.exports = __webpack_public_path__ + "img/bg.2d8f5346.png";